import React from "react";
import Common from "./Common";
import img from "../src/images/rocket.png";

const Home = () => {
    
    return (
    <>
     <Common name=" Grow your bussiness with" 
     imgsrc={img} visit="/service"
      btname="Get Started" /> 
     </>

    );

};
export default Home;